export default "/images/ae3f8294def842241aaf8f177b9669f3.avif";